import firebase from "firebase/app";
import "firebase/functions";

type LogLevel = "info" | "warn" | "error";

export type LogEventPayload = {
  event: string;
  params?: Record<string, string | number | boolean | null>;
  level?: LogLevel;
};

// Cloud Logging にイベントを送信する。
// fire-and-forget セマンティクスは utility 内で完結させ、
// 呼び出し側は .catch を書かなくてよい。
export async function logEvent(payload: LogEventPayload): Promise<void> {
  try {
    const call = firebase
      .app()
      .functions("asia-northeast1")
      .httpsCallable("log_event");
    await call(payload);
  } catch {
    // ログ失敗は本処理を妨げない
  }
}
